<template>
    <section class="component-list flexcontainer full"><Item v-for="item in items" :item="item" :key="item.id"></Item></section>
</template>
<script>
import Item from "./Item.vue";

export default {
    props: { items: Array },
    components: {
        Item
    }
};
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// List.vue?346c713b